import React from 'react';
import CheckoutSection from '../Section';
import Expanded from './Expanded';
import Collapsed from './Collapsed';

export default function ShippingOptions({
  isExpanded,
  canEdit,
  expand,
  collapse
}) {
  return (
    <CheckoutSection
      isExpanded={isExpanded}
      canEdit={canEdit}
      expand={expand}
      collapse={collapse}
      Expanded={Expanded}
      Collapsed={Collapsed}
    />
  );
}
